module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/point04_02_activity-464532db466b32bf21f4282a9de601bd.jpg";